<template>
    <div class="nevs-content">
        <ModalEInvoice @done="eInvoiceDone" :show="eInvoiceModal.show" :invoiceId="eInvoiceModal.invoiceId"></ModalEInvoice>
        <ModalSendEmail @done="sendEmailDone" :show="sendEmailModal.show" :documentId="sendEmailModal.documentId" :customerId="sendEmailModal.customerId" endpoint="invoices"></ModalSendEmail>
        <ModalSendEmailSmtp @done="sendEmailDone" :show="sendEmailSmtpModal.show" :documentId="sendEmailSmtpModal.documentId" :customerId="sendEmailSmtpModal.customerId" endpoint="invoices" :defaultSubject="sendEmailSmtpModal.defaultSubject" :defaultBody="sendEmailSmtpModal.defaultBody"></ModalSendEmailSmtp>
        <div class="nevs-content-top-buttons">
            <NevsButton class="primary help-add" @click="addClick">
                <i class="fa-solid fa-plus"></i>
                {{ $LANG.Get('buttons.add') }}
            </NevsButton>
            <NevsButton class="primary" @click="excelClick">
                <i class="fa-solid fa-file-excel"></i>
                {{ $LANG.Get('buttons.excel') }}
            </NevsButton>
            <NevsButton class="primary" @click="zipClick">
                <i class="fa-solid fa-file-archive"></i>
                {{ $LANG.Get('buttons.zip') }}
            </NevsButton>
            <NevsTableFilters ref="filterPanel" :summary="filterSummary" @clear="clearFilter"
                              @toggle="filtersToggled">
                <NevsTextField v-model="tableData.filters.number" :label="$LANG.Get('fields.number')"></NevsTextField>
                <NevsSelect :nullable="true" v-model="tableData.filters.customer_id" :ajax="'select/customers'"
                            :label="$LANG.Get('fields.customer')"
                            @select="filterLabels.customer_id = $event.label"></NevsSelect>
                <NevsDateField v-model="tableData.filters.date_of_issue_from"
                               :label="$LANG.Get('fields.date_of_issue_from')"></NevsDateField>
                <NevsDateField v-model="tableData.filters.date_of_issue_to"
                               :label="$LANG.Get('fields.date_of_issue_to')"></NevsDateField>
                <NevsSelect :nullable="true" v-model="tableData.filters.invoice_status_id" :ajax="'select/invoice-statuses'"
                            :label="$LANG.Get('fields.status')"
                            @select="filterLabels.invoice_status_id = $event.label"></NevsSelect>
                <NevsSelect :nullable="true" v-model="tableData.filters.payment_method_id" :ajax="'select/payment-methods'"
                            :label="$LANG.Get('fields.paymentMethod')"
                            @select="filterLabels.payment_method_id = $event.label"></NevsSelect>
                <NevsTextField v-model="tableData.filters.item" :label="$LANG.Get('fields.item')"></NevsTextField>
                <NevsSelect v-model="tableData.filters.overpaid" :label="$LANG.Get('fields.overpaid')"
                            :options="$HELPERS.GetYesNoAllOptions(this)"></NevsSelect>
            </NevsTableFilters>
        </div>
        <NevsCard>
            <div v-if="tableData.hasDisclaimers" ref="disclaimerAlert" class="invoice-disclaimer-alert">
                {{ $LANG.Get('labels.someInvoicesHaveDisclaimers') }}
                <NevsCheckbox v-model="tableData.filters.disclaimer"
                              :label="$LANG.Get('labels.onlyInvoicesWithDisclaimers')"></NevsCheckbox>
            </div>
            <NevsTable
                :default-sort="tableData.defaultSort"
                :fields="tableData.fields"
                :height="tableData.height"
                :total-records="tableData.totalRecords"
                @reload="reloadTable">
                <tr v-for="(item, key) in tableData.records" :key="key">
                    <td class="nevs-table-linked-cell help-row" @click="openClick(item.id)">
                        <NevsButton v-if="item.disclaimer != ''" @click.stop="showDisclaimer(item.disclaimer, item.number)" :title="item.disclaimer.replace('%invoice%', item.number)" class="error invoice-disclaimer-button"><i class="fa-solid fa-triangle-exclamation"></i></NevsButton>
                        {{ item.number }}
                        <span class="number-status-pill" v-if="item.e_invoice_id != null" @click.stop="showERInfo(item.id)">ER</span>
                        <span class="number-status-pill" v-if="item.e_reporting_id != null">EI</span>
                        <span class="number-status-pill" v-if="item.zki != '' && item.zki != '-'">F1</span>
                    </td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.date_of_issue_display }}</td>
                    <td class="nevs-table-linked-cell short-customer" @click="openClick(item.id)"
                        :title="item.customer_display">
                        {{ $HELPERS.ShortCustomer(item.customer_display) }}
                    </td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)"><span
                        :class="'status-pill-' + item.invoice_status_id">{{ item.status_display }}</span></td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.links_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{ item.amount_display }}</td>
                    <td class="nevs-table-linked-cell" @click="openClick(item.id)">{{
                            item.financial_status_display
                        }}
                    </td>
                    <td class="nevs-table-linked-cell short-payment-method" @click="openClick(item.id)">
                        {{ item.payment_method_display }}
                    </td>
                    <td class="nevs-table-actions">
                        <NevsActions :width="'210px'" :actions="tableActions" :context="item"></NevsActions>
                    </td>
                </tr>
            </NevsTable>
        </NevsCard>
    </div>
</template>

<script>
import NevsCard from "@/components/nevs/NevsCard.vue";
import NevsButton from "@/components/nevs/NevsButton.vue";
import NevsTable from "@/components/nevs/NevsTable.vue";
import NevsTextField from "@/components/nevs/NevsTextField.vue";
import NevsDateField from "@/components/nevs/NevsDateField.vue";
import NevsSelect from "@/components/nevs/NevsSelect.vue";
import NevsCheckbox from "@/components/nevs/NevsCheckbox.vue";
import ModalEInvoice from "@/components/modals/ModalEInvoice.vue";
import ModalSendEmail from "@/components/modals/ModalSendEmail.vue";
import ModalSendEmailSmtp from "@/components/modals/ModalSendEmailSmtp.vue";
import NevsActions from "@/components/nevs/NevsActions.vue";
import NevsTableFilters from "@/components/nevs/NevsTableFilters.vue";

export default {
    name: "ModuleInvoices",
    components: {NevsTableFilters, NevsActions, ModalEInvoice, ModalSendEmail, ModalSendEmailSmtp, NevsCheckbox, NevsSelect, NevsDateField, NevsTextField, NevsTable, NevsButton, NevsCard},
    data() {
        return {
            eInvoiceModal: {
                show: false,
                invoiceId: null
            },
            sendEmailModal: {
                show: false,
                documentId: null,
                customerId: null
            },
            sendEmailSmtpModal: {
                show: false,
                documentId: null,
                customerId: null,
                defaultSubject: '',
                defaultBody: ''
            },
            tableData: {
                fields: [
                    {
                        name: 'number',
                        label: this.$LANG.Get('fields.number')
                    },
                    {
                        name: 'date_of_issue',
                        label: this.$LANG.Get('fields.dateOfIssue')
                    },
                    {
                        name: 'customer',
                        label: this.$LANG.Get('fields.customer'),
                        sortable: false
                    },
                    {
                        name: 'status',
                        label: this.$LANG.Get('fields.status'),
                        sortable: false
                    },
                    {
                        name: 'connections',
                        label: this.$LANG.Get('labels.connections'),
                        sortable: false
                    },
                    {
                        name: 'amount',
                        label: this.$LANG.Get('labels.amount')
                    },
                    {
                        name: 'financial_status',
                        label: this.$LANG.Get('labels.open')
                    },
                    {
                        name: 'payment_method',
                        label: this.$LANG.Get('fields.paymentMethod'),
                        sortable: false
                    },
                    {
                        name: 'actions',
                        width: '210px',
                        label: '',
                        sortable: false
                    }
                ],
                filters: {
                    number: '',
                    date_of_issue_from: null,
                    date_of_issue_to: null,
                    invoice_status_id: null,
                    customer_id: null,
                    payment_method_id: null,
                    item: '',
                    overpaid: -1,
                    disclaimer: false
                },
                records: [],
                lastRequest: null,
                totalRecords: 0,
                hasDisclaimers: false,
                defaultSort: {
                    field: 'number',
                    descending: true
                },
                filterTimer: null,
                height: '0px'
            },
            tableActions: [
                {
                    label: this.$LANG.Get('tooltips.openInNewWindow'),
                    action: (item) => {
                        this.openClick(item.id, true);
                    },
                    visible: () => {
                        return true;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.pdf'),
                    action: (item) => {
                        this.pdfClick(item.pdf_link);
                    },
                    visible: (item) => {
                        return item.f2_status != 1 && item.f2_status != 3;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.downloadXml'),
                    action: (item) => {
                        this.downloadXmlClick(item.id);
                    },
                    visible: (item) => {
                        return item.e_invoice_id != null;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.email'),
                    action: (item) => {
                        this.emailClick(item);
                    },
                    visible: (item) => {
                        return item.f2_status != 1 && item.f2_status != 3;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.fiskal1'),
                    action: (item) => {
                        this.fiskalClick(item.id);
                    },
                    visible: (item) => {
                        return item.zki !== '' && item.jir === '';
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.eInvoice'),
                    action: (item) => {
                        this.eInvoiceClick(item);
                    },
                    visible: (item) => {
                        return this.$store.state.user.client.e_invoices_token != '' && item.zki == '' && item.f2_status <= 2 && item.payment_method_id == 1 && item.customer_type == 'c' && !item.customer_foreign;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.eReporting'),
                    action: (item) => {
                        this.eReportingClick(item);
                    },
                    visible: (item) => {
                        return item.f2_status == 3 || item.f2_status == 4;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.createDispatchNote'),
                    action: (item) => {
                        this.dispatchNoteClick(item.id);
                    },
                    visible: (item) => {
                        return item.cancels == 0;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.copy'),
                    action: (item) => {
                        this.copyClick(item.id);
                    },
                    visible: (item) => {
                        return item.invoice_status_id !== 5;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.cancel'),
                    action: (item) => {
                        this.cancelClick(item.id);
                    },
                    visible: (item) => {
                        return item.cancellable;
                    }
                },
                {
                    label: this.$LANG.Get('tooltips.delete'),
                    action: (item) => {
                        this.deleteClick(item);
                    },
                    visible: (item) => {
                        return item.deletable;
                    }
                },
            ],
            // Labels of the select filters, for the collapsed filter panel's summary. v-model only carries the
            // id, so the label is captured from NevsSelect's `select` event.
            filterLabels: {
                customer_id: '',
                invoice_status_id: '',
                payment_method_id: ''
            },
            crossTabHandle: null
        }
    },
    computed: {
        // Entries whose value is empty are dropped by NevsTableFilters, so every filter can be listed here and
        // the panel picks the active ones. The disclaimer filter is left out: it lives in the alert above the
        // table, not in the panel.
        filterSummary() {
            let filters = this.tableData.filters;
            return [
                {
                    name: 'number',
                    label: this.$LANG.Get('fields.number'),
                    value: filters.number
                },
                {
                    name: 'customer_id',
                    label: this.$LANG.Get('fields.customer'),
                    value: filters.customer_id === null ? '' : this.filterLabels.customer_id
                },
                {
                    name: 'date_of_issue_from',
                    label: this.$LANG.Get('fields.date_of_issue_from'),
                    value: filters.date_of_issue_from === null ? '' : this.$HELPERS.FormatDate(filters.date_of_issue_from)
                },
                {
                    name: 'date_of_issue_to',
                    label: this.$LANG.Get('fields.date_of_issue_to'),
                    value: filters.date_of_issue_to === null ? '' : this.$HELPERS.FormatDate(filters.date_of_issue_to)
                },
                {
                    name: 'invoice_status_id',
                    label: this.$LANG.Get('fields.status'),
                    value: filters.invoice_status_id === null ? '' : this.filterLabels.invoice_status_id
                },
                {
                    name: 'payment_method_id',
                    label: this.$LANG.Get('fields.paymentMethod'),
                    value: filters.payment_method_id === null ? '' : this.filterLabels.payment_method_id
                },
                {
                    name: 'item',
                    label: this.$LANG.Get('fields.item'),
                    value: filters.item
                },
                {
                    name: 'overpaid',
                    label: this.$LANG.Get('fields.overpaid'),
                    value: filters.overpaid === -1 ? '' : this.$LANG.Get(filters.overpaid === 1 ? 'options.yes' : 'options.no')
                }
            ];
        }
    },
    watch: {
        'tableData.filters.disclaimer'(value) {
            //the disclaimer filter is exclusive, so ticking it clears everything else
            if (value) {
                this.resetFilters();
            }
        },
        'tableData.filters': {
            handler() {
                if (this.filterTimer !== null) {
                    clearTimeout(this.filterTimer);
                }
                let vm = this;
                this.filterTimer = setTimeout(function () {
                    vm.reloadTable(vm.tableData.lastRequest);
                    vm.filterTimerOn = false;
                }, 500);
            },
            deep: true
        }
    },
    methods: {
        showDisclaimer(disclaimer, invoice) {
            let finalDisclaimer = disclaimer.replace('%invoice%', invoice);
            this.$LOCAL_BUS.TriggerEvent('popup', {
                text: finalDisclaimer,
                type: 'alert'
            });
        },
        showERInfo(id) {
            let vm = this;
            this.$API.APICall('get', 'invoices/e-invoice-info/' + id, {}, (data, success) => {
                if (success) {
                    if (data.info != '') {
                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                            text: data.info,
                            type: 'alert'
                        });
                    }
                } else {
                    if (data.info != '') {
                        vm.$LOCAL_BUS.TriggerEvent('popup', {
                            text: vm.$LANG.Get('alerts.noEInvoiceInfoData'),
                            type: 'alert'
                        });
                    }
                }
            });
        },
        downloadXmlClick(id) {
            window.open(this.$store.state.settings.API_BASE + 'invoices/download-xml/' + id);
        },
        dispatchNoteClick(id) {
            this.$router.push('/dispatch-notes/' + id + '/invoice');
        },
        eReportingClick(invoice) {
            this.eInvoiceModal.invoiceId = invoice.id;
            this.$nextTick(()=>{
                this.eInvoiceModal.show = true;
            });
        },
        eInvoiceClick(invoice) {
            this.eInvoiceModal.invoiceId = invoice.id;
            this.$nextTick(()=>{
                this.eInvoiceModal.show = true;
            });
        },
        eInvoiceDone(success) {
            this.eInvoiceModal.show = false;
            this.eInvoiceModal.invoiceId = null;
            if (success) {
                this.$CROSS_TAB_BUS.TriggerEvent('reload-invoices', {});
            }
        },
        emailClick(invoice) {
            if (this.$store.state.user.client.use_smtp) {
                this.sendEmailSmtpModal.documentId = invoice.id;
                this.sendEmailSmtpModal.customerId = invoice.customer_id;
                this.sendEmailSmtpModal.defaultSubject = this.$store.state.user.client.invoice_email_subject;
                this.sendEmailSmtpModal.defaultBody = this.$store.state.user.client.invoice_email_body;
                this.sendEmailSmtpModal.show = true;
            } else {
                this.sendEmailModal.documentId = invoice.id;
                this.sendEmailModal.customerId = invoice.customer_id;
                this.sendEmailModal.show = true;
            }
        },
        sendEmailDone(success) {
            this.sendEmailModal.show = false;
            this.sendEmailModal.documentId = null;
            this.sendEmailModal.customerId = null;
            this.sendEmailSmtpModal.show = false;
            this.sendEmailSmtpModal.documentId = null;
            this.sendEmailSmtpModal.customerId = null;
            if (success) {
                this.$CROSS_TAB_BUS.TriggerEvent('reload-invoices', {});
            }
        },
        pdfClick(link) {
            window.open(link);
        },
        deleteClick(invoice) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.invoiceDeletionQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('delete', 'invoices/' + invoice.id, {}, (data, success) => {
                            if (success) {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-invoices', {});
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        // The value each filter has when it is not restricting anything.
        emptyFilters() {
            return {
                number: '',
                date_of_issue_from: null,
                date_of_issue_to: null,
                invoice_status_id: null,
                customer_id: null,
                payment_method_id: null,
                item: '',
                overpaid: -1
            };
        },
        //the disclaimer filter lives in the alert above the table, not in the filter panel, so it is kept as it is
        resetFilters() {
            this.tableData.filters = Object.assign(this.emptyFilters(), {
                disclaimer: this.tableData.filters.disclaimer
            });
            for (let key in this.filterLabels) {
                this.filterLabels[key] = '';
            }
        },
        clearFilter(entry) {
            this.tableData.filters[entry.name] = this.emptyFilters()[entry.name];
            if (this.filterLabels[entry.name] !== undefined) {
                this.filterLabels[entry.name] = '';
            }
        },
        // Expanding the panel makes it taller, so the table gets whatever height is left over.
        filtersToggled() {
            this.$nextTick(() => {
                this.calculateTableHeight();
            });
        },
        excelClick() {
            let excelRequest = JSON.parse(JSON.stringify(this.tableData.lastRequest));
            excelRequest.rowsPerPage = 0;

            let vm = this;
            vm.$API.APICall('get', 'invoices/excel', excelRequest, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        zipClick() {
            let zipRequest = JSON.parse(JSON.stringify(this.tableData.lastRequest));
            zipRequest.rowsPerPage = 0;

            let vm = this;
            vm.$API.APICall('get', 'invoices/zip', zipRequest, (data, success) => {
                if (success) {
                    window.open(data.link);
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        copyClick(id) {
            this.$router.push('/invoices/' + id + '/copy');
        },
        cancelClick(id) {
            if (this.$store.state.user.invoice_sequences_count === 0) {
                this.$LOCAL_BUS.TriggerEvent('popup', {text: this.$LANG.Get('alerts.noActiveInvoiceSequences'), type: 'alert'});
                this.$router.push('/financial-settings');
                return;
            }
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.invoiceCancellationQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('post', 'invoices/cancel/' + id, {}, (data, success) => {
                            if (success) {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-invoices', {});
                            } else {
                                vm.$HELPERS.HandleServerError(vm, data);
                            }
                        });
                    }
                }
            });
        },
        fiskalClick(id) {
            let vm = this;
            this.$LOCAL_BUS.TriggerEvent('popup', {
                type: 'confirm', text: this.$LANG.Get('alerts.fiskalQuestion'), callback: (response) => {
                    if (response) {
                        vm.$API.APICall('post', 'invoices/fiskal/' + id, {}, (data, success) => {
                            if (success) {
                                vm.$CROSS_TAB_BUS.TriggerEvent('reload-invoices', {});
                            } else {
                                vm.$LOCAL_BUS.TriggerEvent('popup', {
                                    text: vm.$LANG.Get('alerts.fiskalError'),
                                    type: 'alert'
                                });
                            }
                        });
                    }
                }
            });
        },
        openClick(id, newWindow = false) {
            if (newWindow) {
                let routeData = this.$router.resolve('/invoices/' + id + '/edit');
                window.open(routeData.href);
            } else {
                this.$router.push('/invoices/' + id + '/edit');
            }
        },
        addClick() {
            this.$router.push('/invoices/0/add');
        },
        reloadTable(request) {
            let vm = this;
            request.filters = this.tableData.filters;
            this.tableData.lastRequest = JSON.parse(JSON.stringify(request));
            this.$API.APICall('get', 'invoices', request, (data, success) => {
                if (success) {
                    vm.tableData.records = data.records;
                    vm.tableData.totalRecords = data.total_records;
                    vm.tableData.hasDisclaimers = data.has_disclaimers;
                    vm.$nextTick(() => {
                        vm.calculateTableHeight();
                    });
                } else {
                    vm.$HELPERS.HandleServerError(vm, data);
                }
            });
        },
        resolveWindowResize() {
            this.calculateTableHeight();
        },
        calculateTableHeight() {
            let offset = 205;
            //the alert grew a checkbox, so its height is measured instead of hardcoded (5 is its bottom margin)
            if (this.tableData.hasDisclaimers && this.$refs.disclaimerAlert) {
                offset += this.$refs.disclaimerAlert.offsetHeight + 5;
            }
            //the filter panel shares the button row, so only its expanded fields add height above the table
            if (this.$refs.filterPanel) {
                offset += this.$refs.filterPanel.fieldsHeight();
            }
            this.tableData.height = window.innerHeight - offset + 'px';
        }
    },
    mounted() {
        this.$store.commit('setHelpOverlay', [
            {
                class: 'help-add',
                html: this.$LANG.Get('help.add'),
                left: 0,
                top: 0,
                width: 300
            },
            {
                class: 'help-row',
                html: this.$LANG.Get('help.invoiceRow'),
                left: 0,
                top: 0,
                width: 300
            }
        ]);
        this.$store.commit('selectMenu', 'invoices');
        this.$store.commit('selectSubMenu', null);
        this.$store.commit('setBreadcrumbs', [
            {
                label: this.$LANG.Get('modules.invoices'),
                link: null
            }
        ]);
        window.addEventListener('resize', this.resolveWindowResize);
        this.resolveWindowResize();
        let vm = this;
        this.crossTabHandle = this.$CROSS_TAB_BUS.ListenToEvent('reload-invoices', () => {
            vm.reloadTable(vm.tableData.lastRequest);
        });
    },
    unmounted() {
        if (this.crossTabHandle !== null) {
            this.$CROSS_TAB_BUS.UnbindEvent(this.crossTabHandle);
        }
    }
}
</script>

<style scoped lang="scss">
@use '../../scss/vars' as *;

.fiskal-button {
    cursor: pointer;
}

.status-pill-1 {
    width: 100%;
    text-align: center;
    display: inline-block;
    background: $status-open;
    padding: 5px;
    border-radius: 5px;
}

.status-pill-2 {
    width: 100%;
    text-align: center;
    display: inline-block;
    background: $status-pending;
    padding: 5px;
    border-radius: 5px;
}

.status-pill-3 {
    width: 100%;
    text-align: center;
    display: inline-block;
    background: $status-done;
    padding: 5px;
    border-radius: 5px;
}

.status-pill-4 {
    width: 100%;
    text-align: center;
    display: inline-block;
    background: $status-cancelled;
    padding: 5px;
    border-radius: 5px;
}

.status-pill-5 {
    width: 100%;
    text-align: center;
    display: inline-block;
    background: $status-done;
    padding: 5px;
    border-radius: 5px;
}

:deep(.nevs-table-header td) {
    padding-bottom: 10px !important;
}

.invoice-disclaimer-button {
    margin-right: 10px;
}

.invoice-disclaimer-alert {
    background: $banner-warning;
    padding: 10px;
    color: black;
    // No horizontal margin: the table below it sits flush against the card's padding, so anything here would
    // leave the alert visibly narrower than the grid it belongs to.
    margin: 0 0 5px;
    border-radius: 5px;
}

.invoice-disclaimer-alert :deep(.nevs-field) {
    margin-top: 5px;
    width: auto;
}

.number-status-pill {
    display: inline-block;
    background-color: $primary-hover;
    margin-left: 5px;
    padding: 5px;
    border-radius: 5px;
}

@media only screen and (max-width: 1920px) and (-webkit-device-pixel-ratio: 1.25) {
    .short-customer {
        max-width: 200px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: anywhere;
    }

    .short-payment-method {
        max-width: 100px;
        overflow: hidden;
        text-overflow: ellipsis;
        word-wrap: anywhere;
    }
}
</style>